import React, { useEffect } from 'react';

import { Controller } from 'react-hook-form';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage.module.scss';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    className?: string;
    value?: string;
}

export type ProgressMeasurement =
    | 'activityCompleted'
    | 'activityCompletedCriticality'
    | 'activitySubmittedCompletion'
    | 'activitySubmittedCompletionCriticality'
    | 'resourceUnits';

export const options: ISelectOption<ProgressMeasurement>[] = [
    { label: 'Activities Fully Completed - Equally Weighted', value: 'activityCompleted' },
    { label: 'Activities Fully Completed - Criticality Weighted', value: 'activityCompletedCriticality' },
    { label: 'Activities Fully & Partially Completed - Equally Weighted', value: 'activitySubmittedCompletion' },
    {
        label: 'Activities Fully & Partially Completed - Criticality Weighted',
        value: 'activitySubmittedCompletionCriticality',
    },
    { label: 'Resources - Resource Units Weighted', value: 'resourceUnits' },
];

export const ProgressMeasurementFilter = ({
    methods,
    name,
    filtersStatusRef,
    handleFilters,
    className,
    value,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        if (value) {
            methods?.setValue(name, value);
        }
        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [filtersStatusRef, methods, name, value]);

    const handleChange = (option: ISelectOption<string> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (filterValue) => {
        if (!filterValue) {
            return null;
        }
        return options.find((item) => item.value === value) || null;
    };
    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<ProgressMeasurement>>
                            {...field}
                            options={options}
                            id={'global-filter-component-activity-type'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                            label={FilterLabels.progressMeasurement}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
